import { Controller } from '@hotwired/stimulus'

export default class TurboModalController extends Controller {
  static targets = ['button', 'frame', 'modal']

  connect() {
  }

  launch(event) {
    this.frameTarget.src = event.params.url;
  }

  modalTargetConnected() {
    new bootstrap.Modal(this.modalTarget).show();
  }
}
